import {
  telLink,
  whatsappLink,
  type Dwelling,
  type Unit,
} from '@alrimal/contracts';
import { useLocale } from '../LocaleContext.tsx';

/**
 * WhatsApp beside the form, not in the footer (§7).
 *
 * The message is pre-written with the unit the buyer is looking at, so the
 * conversation opens with context instead of «مرحبا». The unified 9200 number
 * is not WhatsApp-capable, so when no mobile is configured this falls back to a
 * `tel:` link rather than rendering a dead button.
 */

export interface ContactActionsProps {
  phone: string;
  whatsapp: string | null;
  context: { unit: Unit; dwelling: Dwelling } | null;
  compact?: boolean;
}

export function ContactActions({
  phone,
  whatsapp,
  context,
  compact = false,
}: ContactActionsProps) {
  const { t } = useLocale();
  const message = context
    ? `مرحبًا، أرغب بالاستفسار عن ${context.dwelling.labelAr} — ${context.unit.id} في مشروع الرمال الواحة.`
    : 'مرحبًا، أرغب بالاستفسار عن مشروع الرمال الواحة.';

  const waHref = whatsapp === null ? null : whatsappLink(whatsapp, message);

  return (
    <div className="contact-actions">
      {waHref ? (
        <a
          className={`btn ${compact ? 'btn--icon' : 'btn--block'}`}
          href={waHref}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('action.whatsapp')}
        </a>
      ) : (
        <a className={`btn ${compact ? 'btn--icon' : 'btn--block'}`} href={telLink(phone)}>
          {t('action.call')} <span className="num">{phone}</span>
        </a>
      )}
    </div>
  );
}
